import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Multi } from "../../../interfaces/multi.interface";


export function NgxMultiValuePercentage(): OperatorFunction<Multi[], Multi[]> {

  return map(multis => {
    const newMultis = multis.map(multi => {

      const total = multi.series.reduce(function (a, b) {
        return a + b.value;
      }, 0);

      const newSeries = multi.series.map(serie => Object.assign({}, serie, { value: Math.round((serie.value / total) * 100) }));
      const newMulti: Multi = Object.assign({}, multi, { series: newSeries });
      return newMulti;
    });

    return newMultis;
  });
}

